<template>
  <div style="width: 100%;">
    <div>
        <div class="mb-0 text-sm text-uppercase font-weight-bold period">{{ period }}</div>
        <h5 style="text-align: left;">Performance</h5>
    </div>
    <div class="container row meter-container" >
        <div id="strain" :title="optimalLabel" class="position-relative" style="width: 130px; height: 130px;">
          <canvas id="strainChart" ref="strainChart" class="position-absolute top-0 start-0"
              style="display: block;margin-left: 0.8rem;" ></canvas>
          <div class="center-text">
            <div class="text-center text-xs text-uppercase">STRAIN</div>
            <div class="text-center font-sans-serif mt-1 pb-3">
              {{ data.strain }}
            </div>
          </div>
        </div>

        <div id="recovery" class="position-relative recovery-circle" 
          :title="data.recovery_score > -1 ? data.recovery_score : 'Calibration in progress'"
          >
            <canvas id="recoveryChart" ref="recoveryChart" style="height:110px !important;width:110px !important;"></canvas>
            <div class="position-absolute top-50 translate-middle-y"
              style="width: 90px !important;padding-left: 0.5rem;padding-top: 0.5rem;">
            <div class="text-center text-xs text-uppercase">Recovery</div>
                <div v-if="data.recovery_score > -1" class="text-center font-sans-serif mt-1 pb-3">
                    {{ data.recovery_score }}%
                </div>
                <div v-else class="text-center font-sans-serif mt-1 pb-3">
                    --
                </div>
            </div>
        </div>

        <div id="sleep" class="position-relative" style="width: 120px !important;height:120px;padding-right: 0 !important;">
            <canvas id="sleepChart" class="donut-canvas" ref="sleepChart" style="height:110px !important;width:110px !important;"></canvas>
            <div class="position-absolute top-50 translate-middle-y" 
                 style="width: 90px !important;padding-left: 0.5rem;padding-top: 0.5rem;">
                <div class="text-center text-xs text-uppercase">Sleep</div>
                <div class="text-center font-sans-serif mt-1 pb-3">
                    {{data.sleep_score}}%
                </div>
            </div>
        </div>
    </div>
    <div v-if="recommendation" style="min-height: 4rem;" class="col-12 recommendation-container">
      <div class="recommendation-details">{{ recommendation }}</div>
    </div>
    <div v-else style="min-height: 4rem;"></div>
  </div>
</template>

<script>
  import Chart from 'chart.js/auto';
  import Utils from "@/helpers/utils.js";
  import Constants from "@/helpers/constants.js";
  import DateUtils from '@/helpers/dateUtils';


  export default {
    name: 'UserPerformanceMeter',
    components: {
    },
    props: {
      id: {
        type: String,
        default: "performance-doughnut-chart",
      },
      title: {
        type: String,
        default: "Performance Chart",
      },
      selectedDate: {
        type: String,
        default: "",
      },
      data: {
        type: Object,
        required: true,
      },
    },
    data() {
        return {
            chartData: this.data,
            recommendation: "",
            recoveryScore: 0,
            warningRecoveryScore: Constants.RECOVERY_WARNING,
            period: '',
            maxStrain: 21,
        }
    },
    computed: {
        optimalLabel() {
            if (this.data && this.data.os_range && this.data.os_range.length === 2) {
                return `Optimal Range: ${this.data.os_range[0]}-${this.data.os_range[1]}`;
            }
            return "Optimal Range: N/A";
        }
    },
    mounted() {
        console.log("mounted UserPerformanceMeter with data", this.data);
        this.period = DateUtils.formatPeriod(this.selectedDate);
        this.initChart();
        this.recommendation = Utils.getRecommendation(this.data.recovery_score);
        this.recoveryScore = this.data.recovery_score;
    },
    methods: {
        initChart() {
            console.log("Initializing charts with data", this.optimalLabel);
            this.destroryCharts();
            this.drawStrainChart();
            let color = this.getColor('Strain', this.chartData.strain);
            //this.createRadialChart(document.getElementById("strainChart").getContext("2d"), 'Strain', this.chartData.strain, color, Constants.MAX_STRAIN);
            color = this.getColor('Recovery', this.chartData.recovery_score);
            this.createRadialChart(document.getElementById("recoveryChart").getContext("2d"), 'Recovery', this.chartData.recovery_score, color, Constants.MAX_RECOVERY_SCORE);
            color = this.getColor('Sleep', this.chartData.sleep_score);
            this.createRadialChart(document.getElementById("sleepChart").getContext("2d"), 'Sleep', this.chartData.sleep_score, color, Constants.MAX_SLEEP_SCORE);
        },
        destroryCharts() {
          let strainChart = Chart.getChart("strainChart");
          if (strainChart != undefined) {
             strainChart.destroy();
          }

          let recoveryChart = Chart.getChart("recoveryChart");
          if (recoveryChart != undefined) {
            recoveryChart.destroy();
          }

          let sleepChart = Chart.getChart("sleepChart");
          if (sleepChart != undefined) {
            sleepChart.destroy();
          }
        },
        getColor(chartName, value) {
            let name = chartName.toLowerCase();
            let color= '';
            if (name == "recovery") {
                if (value <= Constants.RECOVERY_DANGER) {
                    color = "#f0064d";
                } else if (value <= Constants.RECOVERY_WARNING) {
                    color = "#dfa100";
                } else {
                    color = "#469685";
                }
            } else if (name == "sleep") {
                if (value <= Constants.SLEEP_DANGER) {
                    color =  "#f0064d";
                } else if (value <= Constants.SLEEP_WARNING) {
                    color = "#dfa100";
                } else {
                   color = "#469685";
                }
            } else {
              return "#469685";
              // if (value >= Constants.STRAIN_HIGH) {
              //       color = "#469685";
              //   } else if (value < Constants.STRAIN_LOW) {
              //       color = "#f0064d" ;
              //   } else {
              //     color = "#dfa100";
              //   }
            }
            return color;      
       },
       createRadialChart(ctx, label, value, color, maxVal) {
        new Chart(ctx, {
          type: 'doughnut',
          data: {
            datasets: [
              {
                data: [value, maxVal-value],
                backgroundColor: [color, '#364548'],
                borderWidth: 0,
                borderRadius: [10, 0],    
                spacing: 0,
                hoverOffset: 0           
              },
            ],
          },
          options: {
            cutout: '80%',
            plugins: {
              tooltip: { enabled: false },
              legend: { display: false },
              datalabels: {
                display: true,
                color: '#fff',
                font: {
                  size: 20,
                  weight: 'bold',
                },
                formatter: (value, context) => {
                  if (context.dataIndex === 0) {
                    return `${label}\n${value}`;
                  }
                  return '';
                },
              },
            },
          },
        });
       },
    clamp(value, min, max) {
      return Math.max(min, Math.min(value, max));
    },

    valueToAngle(value) {
      const startAngle = -Math.PI / 2;
      return startAngle + (value / this.maxStrain) * Math.PI * 2;
    },

    drawArc(ctx, { cx, cy, radius, startValue, endValue, lineWidth, color }) {
      if (endValue <= startValue) return;

      ctx.beginPath();
      ctx.arc(
        cx,
        cy,
        radius,
        this.valueToAngle(startValue),
        this.valueToAngle(endValue),
        false
      );
      ctx.strokeStyle = color;
      ctx.lineWidth = lineWidth;
      ctx.lineCap = "round";
      ctx.stroke();
    },
    drawStrainChart() {
      const canvas = this.$refs.strainChart;
      if (!canvas) return;

      const ctx = canvas.getContext("2d");
      if (!ctx) return;

      const dpr = window.devicePixelRatio || 1;
      const size = 130;

      // match internal canvas size and CSS size
      canvas.width = size * dpr;
      canvas.height = size * dpr;
      canvas.style.width = `${size}px`;
      canvas.style.height = `${size}px`;

      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.scale(dpr, dpr);
      ctx.translate(0.5, 0.5);
      ctx.clearRect(0, 0, size, size);

      const cx = size / 2;
      const cy = size / 2;
      const radius = size * 0.44; // fixed and predictable

      const trackColor = "#364548";
      const strainColor = "#359685";
      const optimalColor = "#8BE3D3";

      const strainLineWidth = size * 0.1;
      const optimalLineWidth = size * 0.06;

      const strain = this.clamp(Number(this.data.strain) || 0, 0, this.maxStrain);
      let optimalMin = 0;
      let optimalMax = 0;
      if(this.data && this.data.os_range && this.data.os_range.length == 2) {
          optimalMin = this.clamp(Number(this.data.os_range[0]) || 0, 0, this.maxStrain);
          optimalMax = this.clamp(Number(this.data.os_range[1]) || 0, optimalMin, this.maxStrain);
      }

      this.drawArc(ctx, {
        cx,
        cy,
        radius,
        startValue: 0,
        endValue: this.maxStrain,
        lineWidth: strainLineWidth * 1,
        color: trackColor
      });

      this.drawArc(ctx, {
        cx,
        cy,
        radius,
        startValue: 0,
        endValue: strain,
        lineWidth: strainLineWidth,
        color: strainColor
      });

      this.drawArc(ctx, {
        cx,
        cy,
        radius,
        startValue: optimalMin,
        endValue: optimalMax,
        lineWidth: optimalLineWidth,
        color: optimalColor
      });
    },
    },
    watch: {
        data() {
          this.chartData = this.data;
          this.initChart();
          this.recommendation = Utils.getRecommendation(this.data.recovery_score);
        },
        selectedDate() {
          this.period = DateUtils.formatPeriod(this.selectedDate);
        }
    },
}
</script>

<style lang="scss" scoped>
canvas {
  image-rendering: -webkit-optimize-contrast;
  width: 100px !important;
  height: 100px !important;
}
.period {
    font-size: 0.8rem;
    text-align: left;
    color: #359685;
}
.title {
  font-weight: 100;
  font-size: 1.2rem;
  text-align: left;
}
.recommendation-container {
  background-color: rgb(31, 38, 40);
  border-radius: 0.3rem;
  margin-top: 1.5rem;
}
.recommendation-details { 
  font-size: 0.75rem;
  padding: 0.5rem 0.5rem 0.5rem 1rem;
  text-align: start;
  border-radius: 0.5rem;
}
.meter-container {
  background: #283335;
  justify-content: space-around; 
  padding-top: 2rem;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.canvas-size {
  height: 110px;
  width: 110px;
}
.recovery-circle {
  width: 120px !important;
  height:120px;
  padding-right: 0 !important;
}
.center-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -52%); /* slight optical correction */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
</style>